import { useState, useRef, useEffect, useCallback } from "react";

export type ToastType = "success" | "error" | "info";

export interface ToastState {
  type: ToastType;
  message: string;
}

export function useToast(dismissMs = 3000) {
  const [toast, setToast] = useState<ToastState | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const showToast = useCallback(
    (type: ToastType, message: string) => {
      setToast({ type, message });
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setToast(null), dismissMs);
    },
    [dismissMs],
  );

  const dismissToast = useCallback(() => {
    setToast(null);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  return { toast, showToast, dismissToast };
}
